import React, { useState, useRef, useEffect } from 'react';
import ComponentForms from './forms';
import ComponentToolbox from './ComponentToolbox';
import { DraggableComponent } from './DragDrop';
import { ShrinkToFit } from 'interactive';
import ErrorBoundary from './ErrorBoundary';
import InteractiveRenderer from './InteractiveRenderer';
const DEBUG = false;
const requestSearch = (components, query) => {
  DEBUG && console.log("search made!!!");
  if (!query) {
    return components;
  }
  DEBUG && console.log("query is notundef: ", query);
  return components.filter(component => {
    const componentName = component.toLowerCase();
    return componentName.includes(query);
  });
};
const ComponentList = /*#__PURE__*/React.memo(function ComponentList(props) {
  // Generate toolbar button refs
  const toolbarRefs = useRef([]);
  toolbarRefs.current = requestSearch(Object.keys(ComponentToolbox), props.search).map((key, i) => toolbarRefs.current[i] = /*#__PURE__*/React.createRef());
  // toolbar cursor
  const [toolbarCursor, setToolbarCursor] = useState(0);
  // when left or right arrow pressed, change the toolbarCursor
  const handleKeyDown = e => {
    if (e.key === 'ArrowUp' && 0 < toolbarCursor) setToolbarCursor(toolbarCursor - 1);
    if (e.key === 'ArrowDown' && toolbarCursor < toolbarRefs.current.length - 1) setToolbarCursor(toolbarCursor + 1);
  };
  // when toolbarCursor changes, update ariaSelected and change focus
  useEffect(() => {
    toolbarRefs.current[toolbarCursor].current.focus();
  }, [toolbarCursor]);
  const toolbarOut = () => {
    console.log("focused");
    props.focusEditor();
  };
  const toolbarIn = () => {
    toolbarRefs.current[toolbarCursor].current.focus();
  };
  DEBUG && console.log("dragdrop panelLastIndex", props.panelLastIndex, props);
  return /*#__PURE__*/React.createElement("div", {
    className: "components-scroll",
    role: "toolbar",
    onKeyDown: handleKeyDown
  }, requestSearch(Object.keys(ComponentToolbox), props.search).map((key, i) => {
    if (DEBUG && ComponentToolbox[key].tagName === "DesignRow") console.log("gamer time", ComponentToolbox[key].children);
    return /*#__PURE__*/React.createElement(DraggableComponent, {
      key: key + "" + props.dropGeneration,
      id: key,
      index: props.panelLastIndex,
      className: "toolbox-component" + (key === props.selectedComponent ? " selected" : ""),
      onClickCapture: e => {
        e.stopPropagation();
        e.preventDefault();
        props.onClick(key);
      },
      onDrop: props.onDrop,
      onDrag: props.onDrag,
      tabIndex: toolbarCursor == i ? 0 : -1,
      "aria-selected": toolbarCursor == i ? true : false,
      theRef: toolbarRefs.current[i],
      role: "button"
    }, ComponentToolbox[key].type !== "Component" || ComponentForms[ComponentToolbox[key].tagName] ? /*#__PURE__*/React.createElement("h2", {
      className: "center"
    }, key) : /*#__PURE__*/React.createElement("h2", {
      className: "center text-muted",
      title: "No component form available."
    }, key), /*#__PURE__*/React.createElement(ShrinkToFit, {
      style: {
        pointerEvents: 'none'
      }
    }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(InteractiveRenderer, {
      storageKey: key,
      data: ComponentToolbox[key],
      toolbar: true,
      toolbarOut: toolbarOut
    }))));
  }), /*#__PURE__*/React.createElement("div", {
    class: "sr-only",
    "aria-hidden": "true",
    tabindex: 0,
    onFocus: toolbarIn
  }));
});
export default ComponentList;